module.exports = __webpack_public_path__ + "media/images/npcc_logo_long-f7a1c7cbcc3f972ccbdaddf66cf47c57.png";